import React, { useEffect, useRef } from 'react'
import "./About.css"
import { profile2 } from '../../images'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { resume } from '../../images'


const About = () => {
  const container = useRef(null);
  //Register plugin
  gsap.registerPlugin(ScrollTrigger);
  useEffect(() => {
    const el = container.current;
    gsap.fromTo('.about__container', {
      scale: 0.7,
    },
      {
        scale: 1,
        scrollTrigger: {
          trigger: el,
          scrub: true,
          markers: false,
        }
      }
    )
  }, [])





  return (
    <section ref={container} id='about'>
      <div className="section__wrapper about__container">
        <div className="me__container blur-effect">
          <div className="photo__container">
            <img src={profile2} alt="" />
          </div>
        </div>
        <div className="section__header">
          <h4 className='primary__title'>About Me</h4>
          <h1 className='title'>I am <span className='color__primary'>Mohit Kholiya</span></h1>
          <p className="text__muted description">
          
          Curious builder with a love for code that does things. Not the kind to just write lines—I craft tools that make life smoother, faster, or a little more fun. 
          <br></br>
          <br></br>

          Think of me as that friend who sees a problem and starts scribbling wireframes on a napkin. JavaScript? React? Python? They’re my paintbrushes. Whether it’s breathing life into a static webpage or tinkering with AI’s "what-ifs," I’m happiest when turning "Hmm, how?" into "Oh, that’s how."
          <br></br>

          Passionate about tech that feels human—no jargon, no clutter. Just smart solutions hiding behind a click or a swipe. Let’s swap ideas, break a few bugs, and build stuff that matters.
          </p>
          <a href={resume} target="_blank" className="btn btn__primary">Read more</a>
        </div>
      </div>
    </section>
  )
}

export default About
